import React from 'react';
import './CreateCampaignModal.css';

export default function CampaignCreatedModal({ isOpen, onClose, campaignName, onCreateBrief }) {
  if (!isOpen) return null;
  return (
    <div className="create-campaign-modal-overlay">
      <div className="campaign-created-modal">
        <div className="campaign-created-content">
          <h3 className="campaign-created-title">🎉 Campaign Created!</h3>
          <p className="campaign-created-message">
            <strong>'{campaignName}'</strong> is now live and ready for content creation.
          </p>
        </div>

        <div className="campaign-created-actions">
          <button className="campaign-created-secondary-btn" onClick={onClose}>
            Stay Here
          </button>
          <button className="campaign-created-primary-btn" onClick={onCreateBrief}>
            Create Brief
          </button>
        </div>
      </div>
    </div>
  );
}